import * as Yup from "yup";

export const workoutSchema = Yup.object().shape({
    title: Yup.string().required("O título é obrigatório"),
    date: Yup.string().required("A data é obrigatória"),
    description: Yup.string().nullable(),
    blocks: Yup.array().of(
        Yup.object().shape({
            name: Yup.string().required("Nome do bloco é obrigatório"),
            sets: Yup.array().of(
                Yup.object().shape({
                    reps: Yup.number().min(1, "Min. 1").required("Obrigatório"),
                    distance: Yup.number().min(0, "Min. 0").required("Obrigatório"),
                    style: Yup.string().nullable(),
                    intensity: Yup.string().nullable(),
                    interval: Yup.string().nullable(),
                    description: Yup.string().nullable()
                })
            )
        })
    )
});
